import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[3]};
  width: 100%;
`;
